export default __webpack_public_path__ + "static/hero-nz-trail-5d6e2f4efaaff1a6643827f9be060f22.jpg";